import React from "react";

const ChartLegend = ({ items = [] }) => (
  <div className="flex flex-wrap gap-3 text-xs md:text-sm text-mmTextMuted">
    {items.map((item) => (
      <div key={item.label} className="inline-flex items-center gap-2">
        <span
          className={`h-2.5 w-2.5 rounded-full ${item.className || ""}`}
          style={item.color ? { backgroundColor: item.color } : undefined}
          aria-hidden="true"
        />
        <span>{item.label}</span>
      </div>
    ))}
  </div>
);

export default ChartLegend;
